import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import DCCreateSuccess from 'src/plugins/shared/react-components/DCCreateSuccess';
import { iShellyIntegration } from '../shelly.service';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'rgba(21, 22, 23, 1)',
    color: 'rgb(241, 241, 241)',
    fontFamily: 'Inter, arial, sans-serif',
    fontSize: '13px',
    fontWeight: 300,
    paddingBottom: 50,
    paddingLeft: '0px',
    paddingRight: '0px',
    paddingTop: 50,
    position: 'relative',
    userSelect: 'none',
    textAlign: 'center',
  },
  login_form: {
    alignItems: 'center',
    flexDirection: 'column',
    margin: 'auto',
    height: '100%',
    // maxHeight: '250px',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  input: {
    fontFamily: 'Inter, arial, sans-serif',
    fontSize: '16px',
    margin: 0,
    padding: '10px 44px 12px 44px',
    outline: 'none',
    border: '1px solid rgb(90, 93, 98)',
    boxSizing: 'border-box',
    background: 'none',
    borderRadius: 5,
    '-webkitWriting-mode': 'horizontal-tb !important',
    textRendering: 'auto',
    letterSpacing: 'normal',
    wordSpacing: 'normal',
    textTransform: 'none',
    textIndent: 0,
    textShadow: 'none',
    display: 'inline-block',
    textAlign: 'start',
    appearance: 'auto',
    '-webkit-rtl-ordering': 'logical',
    cursor: 'text',
    backgroundColor: 'rgb(0, 0, 0) !important',
    color: 'rgb(241, 241, 241) !important',
    width: '341px',
    marginBottom: '8px',
  },

  submit: {
    backgroundColor: 'rgb(55, 135, 222) !important',
    color: 'rgb(241, 241, 241)',
    textTransform: 'uppercase',
    textAlign: 'center',
    cursor: 'pointer',
    border: 'none',
    fontSize: '13px',
  },
  itgLogo: {
    height: '1.5rem',
  },
});

const IntegratorsSpace: React.FC<{
  src: string;
  integration: iShellyIntegration;
  accountEmail: string;
  showUnlink?: boolean;
  onSuccessCallback?: () => void;
}> = ({
  src, integration, accountEmail, showUnlink, onSuccessCallback,
}) => {
  const classes = useStyles();
  const [success, setSuccess] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const oldSrc = useRef('');

  useEffect(() => {
    if (oldSrc.current !== src) {
      setShowDialog(false);
      oldSrc.current = src;
    }
  }, [src]);

  if (success && !showUnlink) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '90%',
        }}
      >
        <DCCreateSuccess onComplete={onSuccessCallback} onBack={() => setSuccess(false)} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <section className={classes.login_form}>
        <img
          src="data:image/png;base64,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"
          alt="shelly logo"
          className="shelly_logo"
        />
        <h3>
          <img className={classes.itgLogo} src={integration.externalShellyService.logo.ITG_SLL} />
        </h3>
        <Dialog
          style={{ backgroundColor: 'orange' }}
          open={showDialog}
          onClose={() => setShowDialog(false)}
        >
          <DialogTitle style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
            <ReportGmailerrorredIcon />
            <Typography variant="h6">Warning !</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography style={{ fontSize: 16 }}>
              Please ensure that you use this email address
              {' '}
              <span
                style={{ fontWeight: 'bold', color: 'green', cursor: 'pointer' }}
                onClick={() => {
                  navigator.clipboard
                    .writeText(accountEmail)
                    .then(() => {
                      enqueueSnackbar('Copied to Clipboard', { variant: 'info' });
                    })
                    .catch(() => {});
                }}
              >
                {accountEmail}
              </span>
              {' '}
              in the next step to log in to the Shelly Integrators Space.
            </Typography>
            <br />
            <Alert severity="warning">
              <AlertTitle>Warning</AlertTitle>
              <Typography style={{ fontSize: 18 }}>
                In the next screen it is critical to
                {' '}
                <strong>Logout</strong>
                {' '}
                and login as
                {' '}
                <strong>{accountEmail}</strong>
              </Typography>
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button
              size="small"
              color="primary"
              variant="contained"
              onClick={() => setShowDialog(false)}
            >
              Cancel
            </Button>
            <Button
              size="small"
              onClick={() => {
                window.open(src, '_blank');
              }}
            >
              I Understand & Continue
            </Button>
          </DialogActions>
        </Dialog>
        <Button
          // href={src}
          // target="_blank"
          className={classes.input}
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            setShowDialog(true);
          }}
          // rel="noreferrer"
        >
          Open in Shelly Integrators Space
        </Button>
        {!showUnlink && <Button onClick={() => setSuccess(true)}>Next</Button>}
      </section>
    </div>
  );
};

export default IntegratorsSpace;
